import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { faqs } from "../data/landing";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="bg-cream" data-id="element-99" data-mp="1gitw04isywjq">
      <div className="mx-auto max-w-3xl px-5 py-16 md:py-24" data-id="element-100" data-mp="1gjvgezlpkve4">
        <SectionHeading title="Questions fréquentes" data-id="element-101" data-mp="24a91251yrryo" />

        <ul className="mt-10 space-y-3" data-id="element-102" data-mp="24bk7ydqphfu0">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <li key={faq.q} className={`rounded-[1.5rem] bg-white px-5 ring-[3px] transition-[box-shadow] duration-200 md:px-6 ${isOpen ? "ring-tangerine" : "ring-tangerine/20"}`} data-id="element-103" data-mp="1uhacgn6gw1f2" data-mpi={i}>
                <h3 data-id="element-104" data-mp="2rzk5bwiiw4hk">
                  <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-4 text-left focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-royal" data-id="element-105" data-mp="2s03eoou3xkjz">
                    <span className="font-display text-lg font-bold leading-snug text-royal" data-id="element-106" data-mp="19sagc49uhrrd">
                      {faq.q}
                    </span>
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-tangerine" data-id="element-107" data-mp="1jkzputlu4vk2">
                      <PlusIcon className={`h-5 w-5 text-white transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} strokeWidth={3} aria-hidden="true" data-id="element-108" data-mp="1xioaq1fwk2p4" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-109" data-mp="3uem25znrygpa">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-110" data-mp="1yaxsf273ra0p">
                      <p className="pb-5 pr-8 leading-relaxed text-cocoa" data-id="element-111" data-mp="2h7p8z3v9fb12">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}